import React from 'react'
import './index.scss'
import User from 'EurestoClass/User'
import {browserHistory} from 'react-router'

class Index extends React.Component {

  constructor (props) {
    super(props)
  }

  etablissementLibelle = () => {
    return User && User.Entite && User.Entite.get() && User.Entite.get().libelle || ''
  }

  handleClickLogo = () => {
    browserHistory.push({
      pathname: '/'
    })
  }

  render () {
    return (
      <div id="MenuContainer">
        <div className="MenuG" id='appMenu'>
        </div>
      </div>

    )
  }
}

export default Index



// WEBPACK FOOTER //
// ./app/App/Static/Header/index.js